import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import i18n from 'i18next'
import { useEffect, useState } from 'react'

import { FilterButton } from '../../../components/FilterButton/FilterButton'
import { FilteringValue } from '../../../types/filtering'
import { useStyles } from './FilterByText.styles'

type FilterByTextProps = {
  filter: FilteringValue
  onFilter: (value: FilteringValue) => void
  label: string
}

const TextFilterInput = ({ filter, onFilter, label }: FilterByTextProps) => {
  const [localValue, setLocalValue] = useState(filter ?? '')
  const [focused, setFocused] = useState(false)
  const classes = useStyles()

  useEffect(() => {
    setLocalValue(filter ?? '')
  }, [filter])

  const commit = (value: string) => onFilter(value || undefined)

  const clear = () => {
    setLocalValue('')
    onFilter(undefined)
  }

  return (
    <div className={classes.wrapper}>
      <label htmlFor={`filter-text-${label}`} className={classes.label}>
        {label}
      </label>
      <div
        className={`${classes.inputWrapper} ${
          focused ? classes.inputWrapperFocused : ''
        }`}
      >
        <input
          id={`filter-text-${label}`}
          type="text"
          value={localValue}
          placeholder={i18n.t('Filter...')}
          onChange={(e) => setLocalValue(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => {
            setFocused(false)
            commit(localValue)
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') commit(localValue)
          }}
          className={classes.input}
        />
        {localValue && (
          <button
            type="button"
            onMouseDown={(e) => {
              e.preventDefault()
              clear()
            }}
            className={classes.clearButton}
          >
            <FontAwesomeIcon icon={faXmark} size="sm" />
          </button>
        )}
      </div>
    </div>
  )
}

export const FilterByText = ({
  filter,
  onFilter,
  label,
}: FilterByTextProps) => (
  <FilterButton
    filter={filter}
    onFilter={onFilter}
    renderFilter={({ filter: f, onFilter: onF }) => (
      <TextFilterInput filter={f} onFilter={onF} label={label} />
    )}
  />
)
